import path from "node:path";
import { AssetManager } from "@skaile/workspaces/asset-manager";
import { Command } from "commander";
import { colorRef, logInfo, logOk, S } from "../helpers.ts";

/**
 * Creates the `skaile history` command group.
 *
 * Shows recent add/remove/update actions recorded in `.skaile/history.yaml`.
 * Also exposes a `history clear` subcommand to wipe the history file.
 *
 * @returns Configured {@link Command} ready for `program.addCommand()`.
 * @docLink cli/commands/misc#history
 */
export function makeHistoryCommand(): Command {
  const cmd = new Command("history").description("Show recent add/remove/update actions");

  cmd
    .argument("[limit]", "Number of entries to show", "20")
    .option("--project-dir <path>", "Project directory", process.cwd())
    .action((limitStr: string, opts) => {
      const am = new AssetManager({ projectDir: path.resolve(opts.projectDir) });
      const limit = parseInt(limitStr, 10) || 20;
      const entries = am.history(limit);
      if (entries.length === 0) {
        logInfo("No history yet.");
        return;
      }
      const refW = Math.max(3, ...entries.map((e) => e.ref.length));
      console.log();
      console.log(S.heading("  History"));
      console.log(`  ${S.rule(refW + 30)}`);
      for (const e of entries) {
        const when = new Date(e.timestamp).toLocaleDateString();
        console.log(
          `  ${colorRef(e.ref).padEnd(refW + 10)}  ${e.action.padEnd(7)}  ${e.context.padEnd(7)}  ${S.dim(when)}`,
        );
      }
      console.log();
    });

  cmd
    .command("clear")
    .description("Clear action history")
    .option("--project-dir <path>", "Project directory", process.cwd())
    .action((opts) => {
      const am = new AssetManager({ projectDir: path.resolve(opts.projectDir) });
      am.clearHistory();
      logOk("History cleared.");
    });

  return cmd;
}
